import DOMPurify from 'dompurify';

export const convertToHTML = ({ htmlContent }) => {
  // Nettoyer le contenu HTML
  const cleanHTML = DOMPurify.sanitize(htmlContent);

  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: cleanHTML }} />;
};
